// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconBreadcrumbsAngle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9">
            <path
                fill="currentColor"
                d="M4.83793517,4.08367347 C5.05402161,4.30408163 5.05402161,4.69591837 4.83793517,4.91632653 L0.996398559,8.83469388 C0.756302521,9.05510204 0.396158463,9.05510204 0.180072029,8.83469388 C-0.0600240096,8.61428571 -0.0600240096,8.22244898 0.180072029,8.00204082 L3.61344538,4.5 L0.180072029,0.997959184 C-0.0600240096,0.77755102 -0.0600240096,0.410204082 0.180072029,0.165306122 C0.396158463,-0.0551020408 0.756302521,-0.0551020408 0.996398559,0.165306122 L4.83793517,4.08367347 Z"
            />
        </svg>
    );
};

export default React.memo(IconBreadcrumbsAngle);
